
import * as Api from "@/types/graphql";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import { State as StateStore } from "../store";

@Component({
  components: {},
  watch: {
    servicesGuid: {
      handler(val) {
        const serviceIds = val.map((v) => v.guid); 
        const filteredSubServices = this.selectedServicesSubState.filter((s) => serviceIds.includes(s.service_guid));

        this.setSelectedServicesSub(filteredSubServices);
      },
      deep: true,
      immediate: true,
    },
    selectedServicesSubState(val, prev) {
      this.selectedServicesSub = val;
    },
    servicesSubState(val, prev) {
        const list = [];
        this.servicesGuid.forEach((s) => {
            list.push({
                header: s.des,
            })

            list.push(...val.filter((v) => v.service_guid === s.guid))
        })

        this.groupedServicesSub = list;
    }
  },
})
export default class ServicesSubSelector extends Vue {
  @State((state: StateStore) => state.data.servicesSub)
  servicesSubState: Api.ServiceSub[];
  @State((state: StateStore) => state.data.selectedServicesSub)
  selectedServicesSubState: Api.ServiceSub[];

  @Mutation addSelectedServicesSub;
  @Mutation removeSelectedServiceSub;
  @Mutation setSelectedServicesSub;
  @Mutation resetSelectedServicesSub;
  @Action getMultipleServicesSub;

  @Prop({ default: "Seleziona sotto servizio" })
  label: string;
  @Prop({ default: true })
  multiple: boolean;
  @Prop()
  servicesGuid: Api.Service[];

  options = [];
  selectedServicesSub = [];
  selected = [];

  groupedServicesSub = [];

  async mounted() {
    const ids = this.servicesGuid.map((s) => s.guid);
    if (ids.length > 0) {
        await this.getMultipleServicesSub({ servicesGuid: ids });
    }
  }

  filter(item, queryText) {
    if (item.header || (queryText as string)?.length < 3) return false;

    return item.des
      .toString()
      .toLowerCase()
      .includes(queryText.toString().toLowerCase());
  }

  isSelected(service) {
    return _.findIndex(this.selectedServicesSubState, service) > -1;
  }

  onChange(services) {
    if (this.multiple == false) {
      const service = _.differenceBy(
        services,
        this.selectedServicesSubState,
        "guid"
      );
      this.setSelectedServicesSub(service);
    } else {
      this.setSelectedServicesSub(
        _.filter(services, (service) => {
          return service instanceof Object;
        })
      );
    }
  }
}
